import { createReducer, on } from '@ngrx/store';
import * as FollowPredictionActions from '../actions/follow-prediction.actions';

export interface State {
  followedPredictions: any[];
  errorMessage: string | null;
  isLoading: boolean;
}
export const initialState: State = {
  followedPredictions: [],
  errorMessage: null,
  isLoading: false
};

export const followPredictionReducer = createReducer(
  initialState,

  on(FollowPredictionActions.followPrediction, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),

  on(FollowPredictionActions.followPredictionSuccess, (state, { predictionId, userId, id }) => ({
    ...state,
    followedPredictions: [...state.followedPredictions, {
      id: id,
      prediction_id: predictionId.toString(),
      user_id: userId.toString()

    }],
    isLoading: false,
    errorMessage: null
  })),

  on(FollowPredictionActions.followPredictionFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  })),

  on(FollowPredictionActions.unfollowPrediction, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),

  on(FollowPredictionActions.unfollowPredictionSuccess, (state, { predictionId }) => {

    const stringPredictionId = predictionId.toString();
    return {
      ...state,
      followedPredictions: state.followedPredictions.filter(predict => predict["prediction_id"] !== stringPredictionId),
      isLoading: false,
      errorMessage: null
    }
  }),

  on(FollowPredictionActions.unfollowPredictionFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  })),

  on(FollowPredictionActions.loadFollowedPredictions, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),

  on(FollowPredictionActions.loadFollowedPredictionsSuccess, (state, { predictions }) => {

    return {
      ...state,
      followedPredictions: predictions,
      isLoading: false,
      errorMessage: null
    }
  }),

  on(FollowPredictionActions.loadFollowedPredictionsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  }))
);